module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../../node_modules/happypack/loader.js?id=jsx!./GroupBuyListView.js"));
	}, "GroupBuyListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=GroupBuyListView!./src/pages/Shop/Member/TradeManage/OrderList/GroupBuy/GroupBuyList/GroupBuyListView.js
// module id = 1009
// module chunks = 438